import * as React from 'react'

import { Box, Icon, PaginationButton } from '@factorialco/deprecated-design-system'

import usePagination from 'modules/core/components/DataTable/hooks/usePagination'
import i18n from 'modules/core/lib/i18n'

function CursorPagination({ loading }: { loading: boolean }) {
  const { cursorPagination } = usePagination()
  const { actions } = cursorPagination

  return (
    <Box
      flexDirection="row"
      gap="s12"
      justifyContent="flexEnd"
      alignItems="center"
      width="full"
      component="nav"
      aria-label={i18n.t('common.pagination.wrapper')}
    >
      <Box flexDirection="row" gap="s6">
        <PaginationButton
          content={i18n.t('common.pagination.first')}
          ariaLabel={i18n.t('common.pagination.first')}
          onClick={actions.first.onExecute}
          disabled={loading || actions.first.disabled}
          nonInteractive
        />
        <PaginationButton
          content={
            <Icon.Medium
              icon="chevron-left"
              color={loading || actions.previous.disabled ? 'grey400' : 'grey800'}
            />
          }
          ariaLabel={i18n.t('common.pagination.previous')}
          onClick={actions.previous.onExecute}
          disabled={loading || actions.previous.disabled}
          nonInteractive
        />
      </Box>
      <Box flexDirection="row" gap="s6">
        <PaginationButton
          content={
            <Icon.Medium
              icon="chevron-right"
              color={loading || actions.next.disabled ? 'grey400' : 'grey800'}
            />
          }
          ariaLabel={i18n.t('common.pagination.next')}
          onClick={actions.next.onExecute}
          disabled={loading || actions.next.disabled}
          nonInteractive
        />
        <PaginationButton
          content={i18n.t('common.pagination.last')}
          ariaLabel={i18n.t('common.pagination.last')}
          onClick={actions.last.onExecute}
          disabled={loading || actions.last.disabled}
          nonInteractive
        />
      </Box>
    </Box>
  )
}

export default CursorPagination
